module.exports = __webpack_public_path__ + "img/tree.96aa9b12.svg";